export default __webpack_public_path__ + "static/building_pin-unselected.141fb25b9522f4e4bfe430bdd855e9a6.svg";